module.exports = __webpack_public_path__ + "static/media/drawerNav.f9b8dc59.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/docs/assets/drawerNav.PNG
// module id = 260
// module chunks = 0